import React from 'react';
import { useLocalstorage } from 'hooks';
import { useTranslation } from 'react-i18next';
import {
    ActiveLicenses,
    HealthIndex,
    LicensesGranted,
    LicensesSummary
} from './components';

const GRANTED = 'granted';
const HEALTH_INDEX = 'health-index';
const LIST = 'list';
const SUMMARY = 'summary';

const StatisticsLicenses = () => {

    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useLocalstorage('statistics-licenses-tab', {
        defaultValue: SUMMARY
    });

    const tabController = {
        selectedTab,
        setSelectedTab,
        tabs: [{
            label: t('Resumen general'),
            value: SUMMARY
        }, {
            label: t('Licencias activas'),
            value: LIST
        }, {
            label: t('Licencias otorgadas'),
            value: GRANTED
        }, {
            label: t('Índice de control de salud'),
            value: HEALTH_INDEX
        }]
    };

    switch (selectedTab) {
    case (GRANTED): return <LicensesGranted tabController={ tabController } />;
    case (HEALTH_INDEX): return <HealthIndex tabController={ tabController } />;
    case (LIST): return <ActiveLicenses tabController={ tabController } />;
    case (SUMMARY): return <LicensesSummary tabController={ tabController } />;
    default: return <LicensesSummary tabController={ tabController } />;
    }
};

StatisticsLicenses.propTypes = {

};

export default StatisticsLicenses;
